import { useState, type PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

/**
 * TanStack Query provider — same library and role as in twosion-ui and
 * insights-home. Adopted with the metrics feature (the first data-backed
 * screen); a feature's `*.queries.ts` holds its per-query wiring.
 *
 * One client per provider instance, created via `useState` so it survives
 * re-renders but a fresh mount gets a clean cache. Tests use
 * `src/test/renderWithProviders`, which builds its own retry-disabled client.
 */
function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Data is fetched behind Auth0; a 401 won't fix itself on retry.
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });
}

export function QueryProvider({ children }: PropsWithChildren) {
  const [client] = useState(createQueryClient);
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
